module.exports = __webpack_public_path__ + "static/favicon-45bee203a08b6a07f119e592c7c4b452.ico";